import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategory } from "../redux/Slices/CategorySlice";
import styles from "../Style/TaskDetails.module.css";

function ViewCategories() {
  const dispatch = useDispatch();
  const { categories, status, error } = useSelector(
    (state) => state.categoriesReducer
  );
  useEffect(() => {
    dispatch(fetchCategory());
  }, []);
  console.log(categories);

  return (
    <div className="container">
      <div className="row">
        {categories.map((c) => (
          <div className="col-12 col-lg-4 " key={c.id}>
            <div key={c.id} className={styles.taskDetailsContainer}>
              <div className={styles.taskDetailRow}>
                <strong>Category Number: </strong>
                {c.id}
              </div>
              <div className={styles.taskDetailRow}>
                <strong>Category Name : </strong>
                {c.name}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ViewCategories;
